import Handlebars from 'handlebars';
import type { FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNotifications } from '../../../modules/hooks';

interface MessagePreviewModalProps {
  show: boolean;
  handleClose: () => void;
  message: string;
  variables: Record<string, string>;
}

export const MessagePreviewModal: FC<MessagePreviewModalProps> = ({
  show,
  handleClose,
  message,
  variables,
}) => {
  const { setSimpleToasts } = useNotifications()!;
  let renderedMessage = '';

  try {
    const template = Handlebars.compile(message);
    renderedMessage = template(variables);
  } catch (error) {
    renderedMessage = '⚠️ Error rendering the message.';
    setSimpleToasts({ type: 'danger', message: renderedMessage, show: true });
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="post-editor-modal modal-200w"
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title className="editor-title">Message Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Rendered Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            readOnly
            value={renderedMessage}
            style={{ whiteSpace: 'pre-wrap' }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
